// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16012":"dc94ea89","78903":"686ffa28"}[chunkId] + ".chunk.css";
};